import { render, staticRenderFns } from "./ForgeConsent.vue?vue&type=template&id=11637349&scoped=true"
import script from "./ForgeConsent.vue?vue&type=script&lang=js"
export * from "./ForgeConsent.vue?vue&type=script&lang=js"
import style0 from "./ForgeConsent.vue?vue&type=style&index=0&id=11637349&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11637349",
  null
  
)

export default component.exports